// ======================================================================
// File Name       : ServiceTopContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Table, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { SERVICE, SERVICE_DETAIL } from '../../constants/PathConstants';
import TableHead, { setSortState } from '../TableHead';
import { getItemBoxName } from '../../utils/index';
import * as ServiceConstant from '../../constants/ServiceConstant';
import PaginationCustom from '../Pagination';
import CustomLink from '../button/CustomLink';
import * as ICON from '../../constants/IconConstants';

const ServiceList = ({ serviceInfo, handleSortState, serviceSearchInfo, getStartEndData, recordNum, startPosition, handleMouseEnter, handleMouseLeave }) => {
  const thead = [
    { title: 'サービスコード', sortBy: 1 },
    { title: 'サービス名', sortBy: 2 },
    { title: '企業名', sortBy: 3 },
    { title: 'サービス種別', sortBy: 0 },
    { title: '操作', sortBy: null, width: '10%' },
  ];
  let data = thead;
  if (serviceSearchInfo) {
    const sortBy = serviceSearchInfo.serviceSortType;
    const sortState = serviceSearchInfo.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }
  const objectStyle = { 'background-color': 'gray' };
  const serviceList =
    serviceInfo &&
    serviceInfo.serviceList.map((service, index) => {
      const link = SERVICE_DETAIL.replace(':id', service.serviceCd);
      return (
        <tr className={service.dormantState == 1 ? 'inactive-class dormant-object' : 'dormant-object'} key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
          <td>
            {service.serviceCd}
          </td>
          <td>
            {service.serviceName}
          </td>
          <td>
            {service.enterpriseName}
          </td>
          <td>
            {getItemBoxName(ServiceConstant.ServiceType, service.serviceType)}
          </td>
          <td className="text-center padding-clear">
            <CustomLink
              className="margin-right-7 link-detail-edit"
              to={link}
              text="詳細"
            />  
          </td>
        </tr>
      );
    });

  return (
    <div>
      <Table striped hover>
        <thead>
          <TableHead data={data} handleSortState={handleSortState} />
        </thead>
        <tbody>
          {serviceList}
        </tbody>
      </Table>
      <Form.Group>
          <Col className="d-flex justify-content-center">
            <PaginationCustom
              recordNum={recordNum}
              handlePageSelect={getStartEndData}
              startPosition={startPosition}
            />
          </Col>
        </Form.Group>
    </div>
  );
};

export default ServiceList;
